// ---------------------------------------------------------------------------
// View/Background icon SVGs (inline, no external deps)
// ---------------------------------------------------------------------------

export const LandscapeIcon = () => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="4"
      width="16"
      height="10"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const PortraitIcon = () => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="4"
      y="1"
      width="10"
      height="16"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const TrendingIcon = () => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline
      points="1,13 5,9 9,11 13,5 17,3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);
